export const VitalsConfigData = {
  'vital-weight': { unit: 'kg' },
};
